import React from 'react'
import BezierEditor from 'bezier-easing-editor'
import Slider from '@material-ui/lab/Slider'
import Switch from '@material-ui/core/Switch'
import Select from '@material-ui/core/Select'
import { constrain } from '../../utils';

export default class TransitionEditor extends React.Component {

  shouldComponentUpdate(nextProps) {
    const { transitionOptions } = this.props;

    if (
      nextProps.transitionOptions.lastUpdate === transitionOptions.lastUpdate
    ) {
      return false
    }

    return true
  }

  onBezierChange = newBezierValue => {
    const { onTransitionOptionsChange } = this.props;  
    onTransitionOptionsChange(newBezierValue.map(point => parseFloat(point.toFixed(2))), 'bezierCurve');
  }

  formatBezierCurve = bezierCurve => {
    return `(${bezierCurve[0].toFixed(2)}, ${bezierCurve[1].toFixed(
      2
    )}, ${bezierCurve[2].toFixed(2)}, ${bezierCurve[3].toFixed(2)})`
  }

  render() {
    const {
      transitionOptions,
      onTransitionOptionsChange: onChange,
    } = this.props

    return (
      <div className="edit-field-section">

        <div className="edit-field">
          <div className="edit-field-title">Animation</div>
          <div className="edit-field-value">
            <Select
              className="select-field"
              classes={{root: 'select-field__root', select: 'select-field__select'}}
              native
              value={transitionOptions.reveal}
              onChange={e => {
                onChange(e.target.value, 'reveal')
              }}
            >
              <option value="all">All</option>
              <option value="multiline">Multi-Line</option>
              <option value="word">Word</option>
              <option value="character">Character</option>
            </Select>
          </div>
        </div>

        <div className="edit-field">
          <div className="edit-field-title">Direction</div>
          <div className="edit-field-value">
            <Select
              className="select-field"
              classes={{root: 'select-field__root', select: 'select-field__select'}}
              native
              value={transitionOptions.direction}
              onChange={e => {
                onChange(e.target.value, 'direction')
              }}
            >
              <option value="bottom">Bottom</option>
              <option value="top">Top</option>
              <option value="left">Left</option>
              <option value="right">Right</option>
            </Select>
          </div>
        </div>

        <div className="edit-field-group">

          <div className="edit-field half">
            <div className="edit-field-title">Offset</div>
            <div className="edit-field-value">
              <div className="edit-field-input">
                <input 
                  type="number"
                  className="value"
                  min={0}
                  max={1000}
                  value={transitionOptions.offset}
                  onChange={e => {onChange(constrain(e.currentTarget.value, 0, 1000), 'offset')}}
                />
                <div className="unit">px</div>
              </div>
              <Slider
                value={transitionOptions.offset}
                min={0}
                max={1000}
                step={5}              
                onChange={(e, sliderValue) => {
                  onChange(Math.round(sliderValue), 'offset')
                }}
              />
            </div>
          </div>

          <div className="edit-field half">
            <div className="edit-field-title">Duration</div>
            <div className="edit-field-value">
              <div className="edit-field-input">
                <input 
                  type="number"
                  className="value"
                  min={0}
                  max={1000}
                  value={transitionOptions.duration}
                  onChange={e => {onChange(constrain(e.currentTarget.value, 0, 1000), 'duration')}}
                />
                <div className="unit">ms</div>
              </div>
              <Slider
                value={transitionOptions.duration}
                min={10}
                max={5000}
                step={25}              
                onChange={(e, sliderValue) => {
                  onChange(Math.round(sliderValue), 'duration')
                }}
              />
            </div>
          </div>

        </div>


        <div className="edit-field-group">

          {['multiline', 'character', 'word'].includes(transitionOptions.reveal) && (
            <div className="edit-field half">
              <div className="edit-field-title">Line Offset</div>
              <div className="edit-field-value">
                <div className="edit-field-input">
                  <input 
                    type="number"
                    className="value"
                    min={0}
                    max={2000}
                    value={transitionOptions.multilineOffsetDelay}
                    onChange={e => {onChange(constrain(e.currentTarget.value, 0, 2000), 'multilineOffsetDelay')}}
                  />
                  <div className="unit">ms</div>
                </div>
                <Slider
                  value={transitionOptions.multilineOffsetDelay}
                  min={0}
                  max={2000}
                  step={25}
                  aria-labelledby="Multiline Offset Delay"
                  onChange={(e, sliderValue) => {
                    onChange(Math.round(sliderValue), 'multilineOffsetDelay')
                  }}
                />
              </div>
            </div>
          )}

          {['character', 'word'].includes(transitionOptions.reveal) && (
            <div className="edit-field half">
              <div className="edit-field-title">Word Spacing</div>
              <div className="edit-field-value">
                <div className="edit-field-input">
                  <input 
                    type="number"
                    className="value"
                    min={0}
                    max={100}
                    value={transitionOptions.characterWordSpacing}
                    onChange={e => {onChange(constrain(e.currentTarget.value, 0, 100), 'characterWordSpacing')}}
                  />
                  <div className="unit">px</div>
                </div>
                <Slider
                  value={transitionOptions.characterWordSpacing}
                  min={0}
                  max={100}
                  step={1}
                  onChange={(e, sliderValue) => {
                    onChange(Math.round(sliderValue), 'characterWordSpacing')
                  }}
                />
              </div>
            </div>
          )}
          
        </div>

				{['word'].includes(transitionOptions.reveal) && (
					<div className="edit-field half">
						<div className="edit-field-title">Word Offset Delay</div>
            <div className="edit-field-value">
              <div className="edit-field-input">
                <input 
                  type="number"
                  className="value"
                  min={0}
                  max={1000}
                  value={transitionOptions.wordOffsetDelay}
                  onChange={e => {onChange(constrain(e.currentTarget.value, 0, 1000), 'wordOffsetDelay')}}
                />
                <div className="unit">ms</div>
              </div>
              <Slider
                value={transitionOptions.wordOffsetDelay}
                min={0}
                max={1000}
                step={5}
                onChange={(e, sliderValue) => {
                  onChange(Math.round(sliderValue), 'wordOffsetDelay')
                }}
              />
            </div>
					</div>
				)}


				{['character'].includes(transitionOptions.reveal)  && (
					<div className="edit-field half">
						<div className="edit-field-title">Character Offset Delay</div>
              <div className="edit-field-value">
              <div className="edit-field-input">
                <input 
                  type="number"
                  className="value"
                  min={0}
                  max={1000}
                  value={transitionOptions.characterOffsetDelay}
                  onChange={e => {onChange(constrain(e.currentTarget.value, 0, 1000), 'characterOffsetDelay')}}
                />
                <div className="unit">ms</div>
              </div>
              <Slider
                value={transitionOptions.characterOffsetDelay}
                min={0}
                max={1000}
                step={5}                
                onChange={(e, sliderValue) => {
                  onChange(Math.round(sliderValue), 'characterOffsetDelay')
                }}
              />
            </div>
					</div>
				)}

				{['multiline', 'character', 'word'].includes(transitionOptions.reveal) && (
					<div className="edit-field">
						<div className="edit-field-title">Masking</div>
            <div className="edit-field-value">
              <Switch
                checked={transitionOptions.multilineMasking}
                onChange={(e, value) => onChange(value, 'multilineMasking')}
              />
            </div>
					</div>
				)}

        <div className="edit-field">
          <div className="edit-field-title">Opacity</div>
          <div className="edit-field-value">
            <Switch
              checked={transitionOptions.opacity}
              onChange={(e, value) => onChange(value, 'opacity')}
            />
          </div>
        </div>

        
        {transitionOptions.opacity && <div className="edit-field">
          <div className="edit-field-title">Opacity Delay</div>
          <div className="edit-field-value">
            <div className="edit-field-input">
              <input 
                type="number"
                className="value"
                min={0}
                max={2000}
                value={transitionOptions.opacityDelay}
                onChange={e => {onChange(constrain(e.currentTarget.value, 0, 2000), 'opacityDelay')}}
              />
              <div className="unit">ms</div>
            </div>
            <Slider
              value={transitionOptions.opacityDelay}
              min={0}
              max={2000}
              step={25}
              onChange={(e, sliderValue) => {
                onChange(Math.round(sliderValue), 'opacityDelay')            
              }}
            />
          </div>
        </div>}

        <div className="edit-field">
          <div className="edit-field-title">Perspective</div>
          <div className="edit-field-value">
            <Switch
              checked={transitionOptions.perspective}
              onChange={(e, value) => onChange(value, 'perspective')}
            />
          </div>
        </div>

        {transitionOptions.perspective && 
            <div className="edit-field half">
              <div className="edit-field-title">Perspective FOV</div>
              <div className="edit-field-value">
                <div className="edit-field-input">
                  <input 
                    type="number"
                    className="value"
                    min={0}
                    max={5000}
                    value={transitionOptions.perspectiveFOV}
                    onChange={e => {onChange(constrain(e.currentTarget.value, 0, 5000), 'perspectiveFOV')}}
                  />
                  <div className="unit">px</div>
                </div>
                <Slider
                  value={transitionOptions.perspectiveFOV}
                  min={0}
                  max={5000}
                  step={5}
                  onChange={(e, sliderValue) => {
                    onChange(Math.round(sliderValue), 'perspectiveFOV')
                  }}
                />
              </div>
            </div>
          }


        <div className="edit-field-group">
          {transitionOptions.perspective && 
            <div className="edit-field half">
              <div className="edit-field-title">rotateX</div>
              <div className="edit-field-value">
                <div className="edit-field-input">
                  <input 
                    type="number"
                    className="value"
                    min={-359}
                    max={359}
                    value={transitionOptions.perspectiveX}
                    onChange={e => {onChange(constrain(e.currentTarget.value, 0, 359), 'perspectiveX')}}
                  />
                  <div className="unit">deg</div>
                </div>
                <Slider
                  value={transitionOptions.perspectiveX}
                  min={-359}
                  max={359}
                  step={1}              
                  onChange={(e, sliderValue) => {
                    onChange(Math.round(sliderValue), 'perspectiveX')
                  }}
                />
              </div>
            </div>
          }

          {transitionOptions.perspective && 
            <div className="edit-field half">
              <div className="edit-field-title">rotateY</div>
              <div className="edit-field-value">
                <div className="edit-field-input">
                  <input 
                    type="number"
                    className="value"
                    min={-359}
                    max={359}
                    value={transitionOptions.perspectiveY}
                    onChange={e => {onChange(constrain(e.currentTarget.value, 0, 359), 'perspectiveY')}}
                  />
                  <div className="unit">deg</div>
                </div>
                <Slider
                  value={transitionOptions.perspectiveY}
                  min={-359}
                  max={359}
                  step={1}              
                  onChange={(e, sliderValue) => {
                    onChange(Math.round(sliderValue), 'perspectiveY')
                  }}
                />
              </div>
            </div>
          }

        </div>

        <div className="edit-field">
          <div className="edit-field-title">Easing</div>
          <div className="edit-field-value">
            <BezierEditor
              value={transitionOptions.bezierCurve}
              onChange={this.onBezierChange}
            />
          </div>      
        </div>
        <div className="edit-field-input">
          <input 
            disabled
            type="text"
            className="value"
            value={`cubic-bezier${this.formatBezierCurve(transitionOptions.bezierCurve)}`}
          />
          <div className="unit"></div>
        </div>
      </div>
    )
  }
}
